import { GridOptions } from 'ag-grid-community';
import React, { ComponentType, FC, useCallback, useState } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import styled from 'styled-components';

const Mask = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: var(--zindex-layer-02);
`;

export const withEditingMask = <
  T extends Pick<GridOptions, 'onCellEditingStarted' | 'onCellEditingStopped'>,
>(
  Component: ComponentType<T>,
): FC<T> => {
  const Next: FC<T> = ({
    onCellEditingStarted: started,
    onCellEditingStopped: stopped,
    ...props
  }) => {
    const [editing, setEditing] = useState(false);

    const onCellEditingStarted = useCallback(
      (event) => {
        started?.(event);
        setEditing(true);
      },
      [started],
    );

    const onCellEditingStopped = useCallback(
      (event) => {
        stopped?.(event);
        setEditing(false);
      },
      [stopped],
    );

    return (
      <>
        <Component
          {...(props as any)}
          onCellEditingStarted={onCellEditingStarted}
          onCellEditingStopped={onCellEditingStopped}
        />
        {editing ? <Mask /> : null}
      </>
    );
  };

  return setDisplayName(wrapDisplayName(Component, 'WithEditingMask'))(Next);
};
